import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
export const TOKEN_KEY = "inspection_token";

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login") && localStorage.getItem(TOKEN_KEY)) {
    localStorage.removeItem(TOKEN_KEY);
    window.dispatchEvent(new Event("auth:expired"));
  }
  return Promise.reject(err);
});

export const STATUSES = [
  { value: "done", label: "Done" },
  { value: "in_progress", label: "In Progress" },
  { value: "not_started", label: "Not Started" },
];

export const WEATHERS = ["Sunny", "Overcast", "Rain", "Gusty", "High Waves", "Squall"];

export const statusLabel = (s) => STATUSES.find((x) => x.value === s)?.label || "Unassigned";

export const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const todayISO = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
